import { RouteComponentProps } from 'react-router-dom'

import Deposit from './index';

export function RedirectDepositTokenId(
  props: RouteComponentProps<{  currencyIdA: string; }>
) {
  return <Deposit {...props} />
}
